module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_pc_1000-77566aa8cec781b8b91e50a2b4ef92de.png";